<!-- eslint-disable max-len -->
<template>
  <div>
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              MODALS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row>
              <div class="col-10">
                <h2>Dialog</h2>
              </div>
            </b-row>
            <b-row>
              <div class="col-8">
                <button class="btn bg-purple text-white"
                        @click="status=!status"
                >
                  Aç
                </button>
                <b-modal v-model="status"
                         v-bind="config"
                >
                  <div slot="modal-header">
                    <h2>Title</h2>
                  </div>
                  <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div>
                  <div slot="modal-footer">
                    <div>Text</div>
                    <div>
                      <button class="btn md bg-white border-dusk text-color-dusk"
                              @click="status=!status"
                      >
                        KAPAT
                      </button>
                      <button class="btn md bg-purple text-white"
                              @click="status=!status"
                      >
                        ONAYLA
                      </button>
                    </div>
                  </div>
                </b-modal>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Popup',
  data() {
    return {
      config: {
        size: 'md',
        centered: true,
      },
      status: false,
    };
  },
};
</script>
